var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { serverErrorMessage } from '@utils/serverErrorMessage';
import { attachmentsKeys } from './queryKeys';
export function useAttachmentFieldCommit({ entityKey, ownerId, attachmentId, update, genericErrorMessage }) {
    const queryClient = useQueryClient();
    const commit = useCallback((payload) => __awaiter(this, void 0, void 0, function* () {
        try {
            const row = yield update(ownerId, attachmentId, payload);
            queryClient.setQueryData(attachmentsKeys(entityKey).list(ownerId), (rows) => rows === null || rows === void 0 ? void 0 : rows.map((existing) => (existing.id === attachmentId ? row : existing)));
            return { success: true, row };
        }
        catch (error) {
            return { success: false, error: serverErrorMessage(error, genericErrorMessage) };
        }
    }), [entityKey, ownerId, attachmentId, update, genericErrorMessage, queryClient]);
    return { commit };
}
